import { render, staticRenderFns } from "./ViewLoan.vue?vue&type=template&id=a61fbc22&scoped=true"
import script from "./ViewLoan.vue?vue&type=script&lang=js"
export * from "./ViewLoan.vue?vue&type=script&lang=js"
import style0 from "./ViewLoan.vue?vue&type=style&index=0&id=a61fbc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61fbc22",
  null
  
)

export default component.exports